/* eslint-disable */
import { grpc } from "@injectivelabs/grpc-web";
import { BrowserHeaders } from "browser-headers";
import Long from "long";
import _m0 from "protobufjs/minimal.js";
import { Any } from "../../../google/protobuf/any.js";
import { AccessTuple } from "./access_tuple.js";
import { Log } from "./log.js";
import { Params } from "./params.js";
export const protobufPackage = "injective.evm.v1";
function createBaseMsgEthereumTx() {
    return {
        data: undefined,
        size: 0,
        deprecatedHash: "",
        deprecatedFrom: "",
        from: new Uint8Array(),
        raw: new Uint8Array(),
    };
}
export const MsgEthereumTx = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data !== undefined) {
            Any.encode(message.data, writer.uint32(10).fork()).ldelim();
        }
        if (message.size !== 0) {
            writer.uint32(17).double(message.size);
        }
        if (message.deprecatedHash !== "") {
            writer.uint32(26).string(message.deprecatedHash);
        }
        if (message.deprecatedFrom !== "") {
            writer.uint32(34).string(message.deprecatedFrom);
        }
        if (message.from.length !== 0) {
            writer.uint32(42).bytes(message.from);
        }
        if (message.raw.length !== 0) {
            writer.uint32(50).bytes(message.raw);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgEthereumTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.size = reader.double();
                    break;
                case 3:
                    message.deprecatedHash = reader.string();
                    break;
                case 4:
                    message.deprecatedFrom = reader.string();
                    break;
                case 5:
                    message.from = reader.bytes();
                    break;
                case 6:
                    message.raw = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: isSet(object.data) ? Any.fromJSON(object.data) : undefined,
            size: isSet(object.size) ? Number(object.size) : 0,
            deprecatedHash: isSet(object.deprecatedHash) ? String(object.deprecatedHash) : "",
            deprecatedFrom: isSet(object.deprecatedFrom) ? String(object.deprecatedFrom) : "",
            from: isSet(object.from) ? bytesFromBase64(object.from) : new Uint8Array(),
            raw: isSet(object.raw) ? bytesFromBase64(object.raw) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined && (obj.data = message.data ? Any.toJSON(message.data) : undefined);
        message.size !== undefined && (obj.size = message.size);
        message.deprecatedHash !== undefined && (obj.deprecatedHash = message.deprecatedHash);
        message.deprecatedFrom !== undefined && (obj.deprecatedFrom = message.deprecatedFrom);
        message.from !== undefined &&
            (obj.from = base64FromBytes(message.from !== undefined ? message.from : new Uint8Array()));
        message.raw !== undefined &&
            (obj.raw = base64FromBytes(message.raw !== undefined ? message.raw : new Uint8Array()));
        return obj;
    },
    create(base) {
        return MsgEthereumTx.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgEthereumTx();
        message.data = (object.data !== undefined && object.data !== null) ? Any.fromPartial(object.data) : undefined;
        message.size = object.size ?? 0;
        message.deprecatedHash = object.deprecatedHash ?? "";
        message.deprecatedFrom = object.deprecatedFrom ?? "";
        message.from = object.from ?? new Uint8Array();
        message.raw = object.raw ?? new Uint8Array();
        return message;
    },
};
function createBaseLegacyTx() {
    return {
        nonce: "0",
        gasPrice: "",
        gas: "0",
        to: "",
        value: "",
        data: new Uint8Array(),
        v: new Uint8Array(),
        r: new Uint8Array(),
        s: new Uint8Array(),
    };
}
export const LegacyTx = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.nonce !== "0") {
            writer.uint32(8).uint64(message.nonce);
        }
        if (message.gasPrice !== "") {
            writer.uint32(18).string(message.gasPrice);
        }
        if (message.gas !== "0") {
            writer.uint32(24).uint64(message.gas);
        }
        if (message.to !== "") {
            writer.uint32(34).string(message.to);
        }
        if (message.value !== "") {
            writer.uint32(42).string(message.value);
        }
        if (message.data.length !== 0) {
            writer.uint32(50).bytes(message.data);
        }
        if (message.v.length !== 0) {
            writer.uint32(58).bytes(message.v);
        }
        if (message.r.length !== 0) {
            writer.uint32(66).bytes(message.r);
        }
        if (message.s.length !== 0) {
            writer.uint32(74).bytes(message.s);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLegacyTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = longToString(reader.uint64());
                    break;
                case 2:
                    message.gasPrice = reader.string();
                    break;
                case 3:
                    message.gas = longToString(reader.uint64());
                    break;
                case 4:
                    message.to = reader.string();
                    break;
                case 5:
                    message.value = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.v = reader.bytes();
                    break;
                case 8:
                    message.r = reader.bytes();
                    break;
                case 9:
                    message.s = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            nonce: isSet(object.nonce) ? String(object.nonce) : "0",
            gasPrice: isSet(object.gasPrice) ? String(object.gasPrice) : "",
            gas: isSet(object.gas) ? String(object.gas) : "0",
            to: isSet(object.to) ? String(object.to) : "",
            value: isSet(object.value) ? String(object.value) : "",
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            v: isSet(object.v) ? bytesFromBase64(object.v) : new Uint8Array(),
            r: isSet(object.r) ? bytesFromBase64(object.r) : new Uint8Array(),
            s: isSet(object.s) ? bytesFromBase64(object.s) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined && (obj.nonce = message.nonce);
        message.gasPrice !== undefined && (obj.gasPrice = message.gasPrice);
        message.gas !== undefined && (obj.gas = message.gas);
        message.to !== undefined && (obj.to = message.to);
        message.value !== undefined && (obj.value = message.value);
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.v !== undefined && (obj.v = base64FromBytes(message.v !== undefined ? message.v : new Uint8Array()));
        message.r !== undefined && (obj.r = base64FromBytes(message.r !== undefined ? message.r : new Uint8Array()));
        message.s !== undefined && (obj.s = base64FromBytes(message.s !== undefined ? message.s : new Uint8Array()));
        return obj;
    },
    create(base) {
        return LegacyTx.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLegacyTx();
        message.nonce = object.nonce ?? "0";
        message.gasPrice = object.gasPrice ?? "";
        message.gas = object.gas ?? "0";
        message.to = object.to ?? "";
        message.value = object.value ?? "";
        message.data = object.data ?? new Uint8Array();
        message.v = object.v ?? new Uint8Array();
        message.r = object.r ?? new Uint8Array();
        message.s = object.s ?? new Uint8Array();
        return message;
    },
};
function createBaseAccessListTx() {
    return {
        chainId: "",
        nonce: "0",
        gasPrice: "",
        gas: "0",
        to: "",
        value: "",
        data: new Uint8Array(),
        accesses: [],
        v: new Uint8Array(),
        r: new Uint8Array(),
        s: new Uint8Array(),
    };
}
export const AccessListTx = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.nonce !== "0") {
            writer.uint32(16).uint64(message.nonce);
        }
        if (message.gasPrice !== "") {
            writer.uint32(26).string(message.gasPrice);
        }
        if (message.gas !== "0") {
            writer.uint32(32).uint64(message.gas);
        }
        if (message.to !== "") {
            writer.uint32(42).string(message.to);
        }
        if (message.value !== "") {
            writer.uint32(50).string(message.value);
        }
        if (message.data.length !== 0) {
            writer.uint32(58).bytes(message.data);
        }
        for (const v of message.accesses) {
            AccessTuple.encode(v, writer.uint32(66).fork()).ldelim();
        }
        if (message.v.length !== 0) {
            writer.uint32(74).bytes(message.v);
        }
        if (message.r.length !== 0) {
            writer.uint32(82).bytes(message.r);
        }
        if (message.s.length !== 0) {
            writer.uint32(90).bytes(message.s);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccessListTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.nonce = longToString(reader.uint64());
                    break;
                case 3:
                    message.gasPrice = reader.string();
                    break;
                case 4:
                    message.gas = longToString(reader.uint64());
                    break;
                case 5:
                    message.to = reader.string();
                    break;
                case 6:
                    message.value = reader.string();
                    break;
                case 7:
                    message.data = reader.bytes();
                    break;
                case 8:
                    message.accesses.push(AccessTuple.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.v = reader.bytes();
                    break;
                case 10:
                    message.r = reader.bytes();
                    break;
                case 11:
                    message.s = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "0",
            gasPrice: isSet(object.gasPrice) ? String(object.gasPrice) : "",
            gas: isSet(object.gas) ? String(object.gas) : "0",
            to: isSet(object.to) ? String(object.to) : "",
            value: isSet(object.value) ? String(object.value) : "",
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            accesses: Array.isArray(object?.accesses) ? object.accesses.map((e) => AccessTuple.fromJSON(e)) : [],
            v: isSet(object.v) ? bytesFromBase64(object.v) : new Uint8Array(),
            r: isSet(object.r) ? bytesFromBase64(object.r) : new Uint8Array(),
            s: isSet(object.s) ? bytesFromBase64(object.s) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        message.gasPrice !== undefined && (obj.gasPrice = message.gasPrice);
        message.gas !== undefined && (obj.gas = message.gas);
        message.to !== undefined && (obj.to = message.to);
        message.value !== undefined && (obj.value = message.value);
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        if (message.accesses) {
            obj.accesses = message.accesses.map((e) => e ? AccessTuple.toJSON(e) : undefined);
        }
        else {
            obj.accesses = [];
        }
        message.v !== undefined && (obj.v = base64FromBytes(message.v !== undefined ? message.v : new Uint8Array()));
        message.r !== undefined && (obj.r = base64FromBytes(message.r !== undefined ? message.r : new Uint8Array()));
        message.s !== undefined && (obj.s = base64FromBytes(message.s !== undefined ? message.s : new Uint8Array()));
        return obj;
    },
    create(base) {
        return AccessListTx.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccessListTx();
        message.chainId = object.chainId ?? "";
        message.nonce = object.nonce ?? "0";
        message.gasPrice = object.gasPrice ?? "";
        message.gas = object.gas ?? "0";
        message.to = object.to ?? "";
        message.value = object.value ?? "";
        message.data = object.data ?? new Uint8Array();
        message.accesses = object.accesses?.map((e) => AccessTuple.fromPartial(e)) || [];
        message.v = object.v ?? new Uint8Array();
        message.r = object.r ?? new Uint8Array();
        message.s = object.s ?? new Uint8Array();
        return message;
    },
};
function createBaseDynamicFeeTx() {
    return {
        chainId: "",
        nonce: "0",
        gasTipCap: "",
        gasFeeCap: "",
        gas: "0",
        to: "",
        value: "",
        data: new Uint8Array(),
        accesses: [],
        v: new Uint8Array(),
        r: new Uint8Array(),
        s: new Uint8Array(),
    };
}
export const DynamicFeeTx = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.nonce !== "0") {
            writer.uint32(16).uint64(message.nonce);
        }
        if (message.gasTipCap !== "") {
            writer.uint32(26).string(message.gasTipCap);
        }
        if (message.gasFeeCap !== "") {
            writer.uint32(34).string(message.gasFeeCap);
        }
        if (message.gas !== "0") {
            writer.uint32(40).uint64(message.gas);
        }
        if (message.to !== "") {
            writer.uint32(50).string(message.to);
        }
        if (message.value !== "") {
            writer.uint32(58).string(message.value);
        }
        if (message.data.length !== 0) {
            writer.uint32(66).bytes(message.data);
        }
        for (const v of message.accesses) {
            AccessTuple.encode(v, writer.uint32(74).fork()).ldelim();
        }
        if (message.v.length !== 0) {
            writer.uint32(82).bytes(message.v);
        }
        if (message.r.length !== 0) {
            writer.uint32(90).bytes(message.r);
        }
        if (message.s.length !== 0) {
            writer.uint32(98).bytes(message.s);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDynamicFeeTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.nonce = longToString(reader.uint64());
                    break;
                case 3:
                    message.gasTipCap = reader.string();
                    break;
                case 4:
                    message.gasFeeCap = reader.string();
                    break;
                case 5:
                    message.gas = longToString(reader.uint64());
                    break;
                case 6:
                    message.to = reader.string();
                    break;
                case 7:
                    message.value = reader.string();
                    break;
                case 8:
                    message.data = reader.bytes();
                    break;
                case 9:
                    message.accesses.push(AccessTuple.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.v = reader.bytes();
                    break;
                case 11:
                    message.r = reader.bytes();
                    break;
                case 12:
                    message.s = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "0",
            gasTipCap: isSet(object.gasTipCap) ? String(object.gasTipCap) : "",
            gasFeeCap: isSet(object.gasFeeCap) ? String(object.gasFeeCap) : "",
            gas: isSet(object.gas) ? String(object.gas) : "0",
            to: isSet(object.to) ? String(object.to) : "",
            value: isSet(object.value) ? String(object.value) : "",
            data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(),
            accesses: Array.isArray(object?.accesses) ? object.accesses.map((e) => AccessTuple.fromJSON(e)) : [],
            v: isSet(object.v) ? bytesFromBase64(object.v) : new Uint8Array(),
            r: isSet(object.r) ? bytesFromBase64(object.r) : new Uint8Array(),
            s: isSet(object.s) ? bytesFromBase64(object.s) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        message.gasTipCap !== undefined && (obj.gasTipCap = message.gasTipCap);
        message.gasFeeCap !== undefined && (obj.gasFeeCap = message.gasFeeCap);
        message.gas !== undefined && (obj.gas = message.gas);
        message.to !== undefined && (obj.to = message.to);
        message.value !== undefined && (obj.value = message.value);
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        if (message.accesses) {
            obj.accesses = message.accesses.map((e) => e ? AccessTuple.toJSON(e) : undefined);
        }
        else {
            obj.accesses = [];
        }
        message.v !== undefined && (obj.v = base64FromBytes(message.v !== undefined ? message.v : new Uint8Array()));
        message.r !== undefined && (obj.r = base64FromBytes(message.r !== undefined ? message.r : new Uint8Array()));
        message.s !== undefined && (obj.s = base64FromBytes(message.s !== undefined ? message.s : new Uint8Array()));
        return obj;
    },
    create(base) {
        return DynamicFeeTx.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDynamicFeeTx();
        message.chainId = object.chainId ?? "";
        message.nonce = object.nonce ?? "0";
        message.gasTipCap = object.gasTipCap ?? "";
        message.gasFeeCap = object.gasFeeCap ?? "";
        message.gas = object.gas ?? "0";
        message.to = object.to ?? "";
        message.value = object.value ?? "";
        message.data = object.data ?? new Uint8Array();
        message.accesses = object.accesses?.map((e) => AccessTuple.fromPartial(e)) || [];
        message.v = object.v ?? new Uint8Array();
        message.r = object.r ?? new Uint8Array();
        message.s = object.s ?? new Uint8Array();
        return message;
    },
};
function createBaseExtensionOptionsEthereumTx() {
    return {};
}
export const ExtensionOptionsEthereumTx = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseExtensionOptionsEthereumTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return ExtensionOptionsEthereumTx.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseExtensionOptionsEthereumTx();
        return message;
    },
};
function createBaseMsgEthereumTxResponse() {
    return { hash: "", logs: [], ret: new Uint8Array(), vmError: "", gasUsed: "0", blockHash: new Uint8Array() };
}
export const MsgEthereumTxResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        for (const v of message.logs) {
            Log.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.ret.length !== 0) {
            writer.uint32(26).bytes(message.ret);
        }
        if (message.vmError !== "") {
            writer.uint32(34).string(message.vmError);
        }
        if (message.gasUsed !== "0") {
            writer.uint32(40).uint64(message.gasUsed);
        }
        if (message.blockHash.length !== 0) {
            writer.uint32(50).bytes(message.blockHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgEthereumTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                case 2:
                    message.logs.push(Log.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.ret = reader.bytes();
                    break;
                case 4:
                    message.vmError = reader.string();
                    break;
                case 5:
                    message.gasUsed = longToString(reader.uint64());
                    break;
                case 6:
                    message.blockHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash) ? String(object.hash) : "",
            logs: Array.isArray(object?.logs) ? object.logs.map((e) => Log.fromJSON(e)) : [],
            ret: isSet(object.ret) ? bytesFromBase64(object.ret) : new Uint8Array(),
            vmError: isSet(object.vmError) ? String(object.vmError) : "",
            gasUsed: isSet(object.gasUsed) ? String(object.gasUsed) : "0",
            blockHash: isSet(object.blockHash) ? bytesFromBase64(object.blockHash) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        if (message.logs) {
            obj.logs = message.logs.map((e) => e ? Log.toJSON(e) : undefined);
        }
        else {
            obj.logs = [];
        }
        message.ret !== undefined &&
            (obj.ret = base64FromBytes(message.ret !== undefined ? message.ret : new Uint8Array()));
        message.vmError !== undefined && (obj.vmError = message.vmError);
        message.gasUsed !== undefined && (obj.gasUsed = message.gasUsed);
        message.blockHash !== undefined &&
            (obj.blockHash = base64FromBytes(message.blockHash !== undefined ? message.blockHash : new Uint8Array()));
        return obj;
    },
    create(base) {
        return MsgEthereumTxResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgEthereumTxResponse();
        message.hash = object.hash ?? "";
        message.logs = object.logs?.map((e) => Log.fromPartial(e)) || [];
        message.ret = object.ret ?? new Uint8Array();
        message.vmError = object.vmError ?? "";
        message.gasUsed = object.gasUsed ?? "0";
        message.blockHash = object.blockHash ?? new Uint8Array();
        return message;
    },
};
function createBaseMsgUpdateParams() {
    return { authority: "", params: undefined };
}
export const MsgUpdateParams = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: isSet(object.authority) ? String(object.authority) : "",
            params: isSet(object.params) ? Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        return obj;
    },
    create(base) {
        return MsgUpdateParams.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = (object.params !== undefined && object.params !== null)
            ? Params.fromPartial(object.params)
            : undefined;
        return message;
    },
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
export const MsgUpdateParamsResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return MsgUpdateParamsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
};
export class MsgClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.EthereumTx = this.EthereumTx.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    EthereumTx(request, metadata) {
        return this.rpc.unary(MsgEthereumTxDesc, MsgEthereumTx.fromPartial(request), metadata);
    }
    UpdateParams(request, metadata) {
        return this.rpc.unary(MsgUpdateParamsDesc, MsgUpdateParams.fromPartial(request), metadata);
    }
}
export const MsgDesc = { serviceName: "injective.evm.v1.Msg" };
export const MsgEthereumTxDesc = {
    methodName: "EthereumTx",
    service: MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return MsgEthereumTx.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = MsgEthereumTxResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const MsgUpdateParamsDesc = {
    methodName: "UpdateParams",
    service: MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return MsgUpdateParams.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = MsgUpdateParamsResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export class GrpcWebImpl {
    host;
    options;
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        const request = { ..._request, ...methodDesc.requestType };
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc.Code.OK) {
                        resolve(response.message.toObject());
                    }
                    else {
                        const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
                        reject(err);
                    }
                },
            });
        });
    }
}
var tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (tsProtoGlobalThis.Buffer) {
        return Uint8Array.from(tsProtoGlobalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = tsProtoGlobalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (tsProtoGlobalThis.Buffer) {
        return tsProtoGlobalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return tsProtoGlobalThis.btoa(bin.join(""));
    }
}
function longToString(long) {
    return long.toString();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
export class GrpcWebError extends tsProtoGlobalThis.Error {
    code;
    metadata;
    constructor(message, code, metadata) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
